import { Outlet } from "react-router-dom";
import Navbar from "./Navbar/Navbar";

const AuthenticationLayout = () => {
  return (
    <main>
      <Navbar />
      <Outlet />
    </main>
  );
};
export default AuthenticationLayout;
